export default {
  'pages.layouts.userLayout.title':
    '',
  'pages.login.accountLogin.tab': '账户密码登录',
  'pages.login.accountLogin.errorMessage':
    '错误的用户名和密码',
  'pages.login.title': '家用智能设备云管理后台系统',
  'pages.login.loginTips': '请输入您的用户名和密码',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.success': '登录成功！',
  'pages.login.username.placeholder': '请输入技诺用户名',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.password.required': '密码是必填项！',
  'pages.login.phoneLogin.tab': '手机号登录',
  'pages.login.phoneLogin.errorMessage': '验证码错误',
  'pages.login.phoneNumber.placeholder': '请输入手机号！',
  'pages.login.phoneNumber.required': '手机号是必填项！',
  'pages.login.phoneNumber.invalid': '不合法的手机号！',
  'pages.login.captcha.placeholder': '请输入验证码！',
  'pages.login.captcha.required': '验证码是必填项！',
  'pages.login.phoneLogin.getVerificationCode': '获取验证码',
  'pages.getCaptchaSecondText': '秒后重新获取',
  'pages.login.rememberMe': '记住密码',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.login.submit': '登录',
  'pages.login.loginWith': '其他登录方式 :',
  'pages.login.registerAccount': '注册账户',

  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  'pages.admin.subPage.alertMessage':
    'umi ui 现已发布，欢迎使用 npm run ui 启动体验。',
  'pages.accessControl.pageTitle': '权限管理',

  'pages.accessControl.selectedCount': '已选择 {count} 项',
  'pages.accessControl.columns.name': '用户姓名',
  'pages.accessControl.columns.email': '电子邮箱',
  'pages.accessControl.columns.phone': '手机号码',
  'pages.accessControl.columns.access': '权限级别',
  'pages.accessControl.columns.action': '操作',
  'pages.accessControl.actions.edit': '编辑权限',
  'pages.accessControl.editModalTitle': '编辑用户权限',
  'pages.accessControl.editUserName': '用户: {name}',
  'pages.accessControl.newAccess': '新权限级别',
  'pages.accessControl.access.admin': '管理员',
  'pages.accessControl.access.user': '普通用户',
  'pages.accessControl.access.visitor': '访客',
  'pages.accessControl.updateSuccess': '权限更新成功',
  'pages.accessControl.updateFailed': '权限更新失败',
  /** 欢迎页 */
  'pages.welcome.title': '家用智能设备云管理后台系统',
  'pages.welcome.link': '欢迎使用',
  'pages.welcome.subtitle': '实时数据监控与分析平台',
  'pages.welcome.stat.onlineDevices': '在线设备',
  'pages.welcome.stat.totalDevices': '总设备数',
  'pages.welcome.stat.registeredUsers': '注册用户数量',
  'pages.welcome.stat.onlineUsers': '在线用户数量',
  'pages.welcome.chart.weeklyCups': '本周制作杯数',
  'pages.welcome.chart.todayRatio': '今日咖啡类型占比',
  'pages.welcome.chart.noData': '暂无数据',
  'pages.welcome.chart.materialTotal': '物料损耗总数',
  'pages.welcome.chart.globalMap': '全球咖啡机地图',
  'pages.welcome.chart.salesCups': '销售杯数',
  'pages.welcome.chart.cupsUnit': '{cups}杯',
  'pages.welcome.chart.total': '总计',
  'pages.welcome.material.rawLoss': '原料损耗总数',
  'pages.welcome.material.consumableLoss': '耗材损耗总数',
  'pages.welcome.material.maintainLoss': '维护用品损耗总数',
  'pages.welcome.material.coffeeBeans': '咖啡豆',
  'pages.welcome.material.water': '水',
  'pages.welcome.material.milk': '牛奶',
  'pages.welcome.material.chocolate': '巧克力酱',
  'pages.welcome.material.filterPaper': '滤纸',
  'pages.welcome.material.cleaningTablets': '清洁片',
  'pages.welcome.material.lubricant': '润滑油',
  'pages.welcome.material.descaling': '除垢剂',
  'pages.welcome.material.unitG': 'g',
  'pages.welcome.material.unitMl': 'ml',
  'pages.welcome.material.unitPcs': '张',
  'pages.welcome.material.unitTablets': '片',
  'pages.welcome.material.category.raw': '原料',
  'pages.welcome.material.category.consumable': '耗材',
  'pages.welcome.material.category.maintain': '维护',
  'pages.welcome.day.sun': '周日',
  'pages.welcome.day.mon': '周一',
  'pages.welcome.day.tue': '周二',
  'pages.welcome.day.wed': '周三',
  'pages.welcome.day.thu': '周四',
  'pages.welcome.day.fri': '周五',
  'pages.welcome.day.sat': '周六',
  'pages.welcome.refresh': '刷新数据',
  'pages.welcome.globe.loading': '加载3D地球模型...',
  'pages.welcome.globe.error': '加载地球模型失败',
  'pages.welcome.globe.retry': '重试',
  'pages.welcome.globe.deviceCount': '设备数量',
  'pages.accessControl.operation': '操作',
  /** 角色管理页 */
  'pages.accessControl.roleManagement.roleId': '角色ID',
  'pages.accessControl.roleManagement.roleName': '角色名称',
  'pages.accessControl.roleManagement.status': '状态',
  'pages.accessControl.roleManagement.roleDescription': '角色标识',
  'pages.accessControl.roleManagement.permissionCount': '权限数量',
  'pages.accessControl.roleManagement.createTime': '创建时间',
  'pages.accessControl.roleManagement.editRole': '编辑角色',
  'pages.accessControl.roleManagement.enableRole': '启用',
  'pages.accessControl.roleManagement.disableRole': '禁用',
  'pages.accessControl.roleManagement.addRole': '新增角色',
  'pages.accessControl.roleManagement.editRole': '编辑角色',
  'pages.accessControl.roleManagement.basicInfo': '基本信息',
  'pages.accessControl.roleManagement.permissionConfig': '权限配置',
  'pages.accessControl.roleManagement.roleMark': '角色标识',
  'pages.accessControl.roleManagement.placeholderName': '请输入角色名称',
  'pages.accessControl.roleManagement.ruleName': '请输入角色名称',
  'pages.accessControl.roleManagement.ruleNameMax': '角色名称长度不能超过20个字符',
  'pages.accessControl.roleManagement.placeholderMark': '请输入角色标识',
  'pages.accessControl.roleManagement.ruleMark': '请输入角色标识',
  'pages.accessControl.roleManagement.ruleMarkMax': '角色标识长度不能超过50个字符',
  'pages.accessControl.roleManagement.rulePermission': '请至少选择一个权限',
  'pages.accessControl.roleManagement.loading': '加载中...',
  'pages.accessControl.roleManagement.loadPermissionFailed': '获取权限列表数据失败',
  'pages.accessControl.roleManagement.deleteConfirm': '确定要删除这个角色吗？删除后无法恢复。',
  'pages.accessControl.roleManagement.deleteSuccess': '角色删除成功',
  'pages.accessControl.roleManagement.deleteFailed': '角色删除失败',
  'pages.accessControl.roleManagement.editSuccess': '角色编辑成功',
  'pages.accessControl.roleManagement.editFailed': '角色编辑失败',
  'pages.accessControl.roleManagement.createSuccess': '角色新增成功',
  'pages.accessControl.roleManagement.createFailed': '角色新增失败',
  'pages.accessControl.roleManagement.loadFailed': '获取角色列表失败',
  'pages.accessControl.userManagement.addUser': '新增用户',
  'pages.accessControl.userManagement.deleteConfirm': '确定要删除这个用户吗？删除后无法恢复。',
  'pages.accessControl.userManagement.deleteSuccess': '用户删除成功',
  'pages.accessControl.userManagement.deleteFailed': '用户删除失败',
  'pages.accessControl.userManagement.editSuccess': '用户信息更新成功',
  'pages.accessControl.userManagement.editFailed': '用户信息更新失败',
  'pages.accessControl.userManagement.createSuccess': '用户新增成功',
  'pages.accessControl.userManagement.createFailed': '用户新增失败',
  'pages.accessControl.userManagement.loadFailed': '获取用户列表失败',
  'pages.accessControl.userManagement.statusChanged': '{userName} {status}',
  'pages.accessControl.userManagement.statusFailed': '更新用户状态失败',
  'pages.accessControl.userManagement.basicInfo': '基本信息',
  'pages.accessControl.userManagement.editUser': '编辑用户',
  'pages.accessControl.userManagement.password': '密码',
  'pages.accessControl.userManagement.confirmPassword': '确认密码',
  'pages.accessControl.userManagement.role': '角色',
  'pages.accessControl.userManagement.placeholderEmail': '请输入邮箱',
  'pages.accessControl.userManagement.ruleEmail': '请输入邮箱',
  'pages.accessControl.userManagement.ruleEmailValid': '请输入有效的邮箱地址',
  'pages.accessControl.userManagement.placeholderPassword': '请输入密码',
  'pages.accessControl.userManagement.rulePassword': '请输入密码',
  'pages.accessControl.userManagement.rulePasswordMin': '密码长度至少为6个字符',
  'pages.accessControl.userManagement.rulePasswordMax': '密码长度不能超过20个字符',
  'pages.accessControl.userManagement.placeholderConfirm': '请确认密码',
  'pages.accessControl.userManagement.ruleConfirm': '请确认密码',
  'pages.accessControl.userManagement.rulePasswordMismatch': '两次输入的密码不一致',
  'pages.accessControl.userManagement.placeholderNick': '请输入昵称',
  'pages.accessControl.userManagement.ruleNick': '请输入昵称',
  'pages.accessControl.userManagement.ruleNickMax': '昵称长度不能超过50个字符',
  'pages.accessControl.userManagement.placeholderRole': '请选择角色（可多选）',
  'pages.accessControl.userManagement.ruleRole': '请至少选择一个角色',
  /** 菜单管理页 */
  'pages.accessControl.menuManagement.createMenu': '新增目录',
  'pages.accessControl.menuManagement.editMenu': '编辑菜单',
  /** 用户管理页 */
  'pages.accessControl.userManagement.id': '用户ID',
  'pages.accessControl.userManagement.user_name': '用户名',
  'pages.accessControl.userManagement.email': '邮箱',
  'pages.accessControl.userManagement.nickName': '昵称',
  'pages.accessControl.userManagement.status': '状态',
  'pages.accessControl.userManagement.operation': '操作',
  'pages.accessControl.userManagement.addUser': '新增用户',
  // 设备管理 - 设备列表
  'pages.deviceControl.deviceManagement.deviceId': 'SN码',
  'pages.deviceControl.deviceManagement.vmc_no': '设备号',
  'pages.deviceControl.deviceManagement.deviceName': '设备名称',
  'pages.deviceControl.deviceManagement.region-device': '设备区域',
  'pages.deviceControl.deviceManagement.device_model': '设备型号',
  'pages.deviceControl.deviceManagement.use_status': '设备状态',
  'pages.deviceControl.deviceManagement.iot_status': '状态',
  'pages.deviceControl.deviceManagement.device_config_id': '设备配置',
  'pages.deviceControl.deviceManagement.ipAddress': 'IP地址',
  'pages.deviceControl.deviceManagement.createTime': '创建时间',
  'pages.deviceControl.deviceManagement.lastOnlineTime': '最后在线时间',
  // 设备管理 - 设备系列
  'pages.deviceControl.seriesDevice.deviceSeriesID': '系列ID',
  'pages.deviceControl.seriesDevice.deviceSeriesName': '系列名称',
  'pages.deviceControl.seriesDevice.deviceSeriesDescription': '系列描述',
  'pages.deviceControl.seriesDevice.manufacturer': '制造商',
  'pages.deviceControl.seriesDevice.createTime': '创建时间',
  'pages.deviceControl.seriesDevice.updateTime': '更新时间',
  'pages.deviceControl.seriesDevice.operation': '操作',
  'pages.deviceControl.seriesDevice.editSeries': '编辑设备系列',
  'pages.deviceControl.seriesDevice.addSeries': '新增设备系列',
  // 设备管理 - 设备分类
  'pages.deviceControl.categoryDevice.deviceCategoryID': 'ID',
  'pages.deviceControl.categoryDevice.deviceCategoryName': '分类名称',
  // 设备管理 - 设备型号
  'pages.deviceControl.modelDevice.deviceModelID': 'ID',
  'pages.deviceControl.modelDevice.deviceModelName': '型号名称',
  'pages.deviceControl.modelDevice.deviceCategory': '设备分类',
  'pages.deviceControl.modelDevice.promotionName': '外部型号（宣传型号）',
  'pages.deviceControl.modelDevice.deviceType': '设备类型',
  'pages.deviceControl.modelDevice.serial': '串口',
  'pages.deviceControl.modelDevice.android': '安卓',
  // 设备管理 - 配置组设备
  'pages.deviceControl.configGroupDevice.configGroupID': 'ID',
  'pages.deviceControl.configGroupDevice.configGroupName': '配置组名称',
  'pages.deviceControl.configGroupDevice.createUser': '创建人',
  'pages.deviceControl.configGroupDevice.createTime': '创建时间',
  'pages.deviceControl.configGroupDevice.updateTime': '更新时间',
  // 设备管理 - 配置设备
  'pages.deviceControl.configDevice.editConfig': '编辑设备配置',
  'pages.deviceControl.configDevice.addConfig': '新增设备配置',
  'pages.deviceControl.configDevice.configName': '配置名称',
  'pages.deviceControl.configDevice.configNamePlaceholder': '请输入配置名称',
  'pages.deviceControl.configDevice.configNameRequired': '请输入配置名称',
  'pages.deviceControl.configDevice.configNameMaxLength': '配置名称长度不能超过50个字符',
  'pages.deviceControl.configDevice.specs': '规格',
  'pages.deviceControl.configDevice.specsPlaceholder': '请输入规格',
  'pages.deviceControl.configDevice.specsRequired': '请输入规格',
  'pages.deviceControl.configDevice.statusPlaceholder': '请选择状态',
  'pages.deviceControl.configDevice.statusRequired': '请选择状态',
  'pages.deviceControl.configDevice.configGroup': '配置组',
  'pages.deviceControl.configDevice.configGroupPlaceholder': '请选择配置组',
  'pages.deviceControl.configDevice.configGroupRequired': '请选择配置组',
  'pages.deviceControl.configDevice.notSelected': '未选择',
  'pages.deviceControl.configDevice.deviceModel': '设备型号（多选）',
  'pages.deviceControl.configDevice.deviceModelPlaceholder': '请选择设备型号',
  'pages.deviceControl.configDevice.fetchModelFailed': '获取设备型号列表失败',
  'pages.deviceControl.configDevice.fetchGroupFailed': '获取配置组列表失败',
  'pages.deviceControl.configDevice.configDeviceID': 'ID',
  'pages.deviceControl.configDevice.configName': '配置名称',
  'pages.deviceControl.configDevice.specs': '规格',
  'pages.deviceControl.configDevice.device_config_group_name': '配置组名称',
  'pages.deviceControl.configDevice.configIDGroup': 'ID',
  'pages.deviceControl.configDevice.device_model_name': '设备型号名称',
  'pages.deviceControl.configDevice.configType': '配置类型',
  'pages.deviceControl.configDevice.createTime': '创建时间',
  'pages.deviceControl.configDevice.updateTime': '更新时间',
  // 设备管理 - 饮品配方
  'pages.deviceControl.drinkManagement.drinkID': 'ID',
  'pages.deviceControl.drinkManagement.drinkName': '饮品名称',
  'pages.deviceControl.drinkManagement.drinkType': '饮品类型',
  'pages.deviceControl.drinkManagement.createTime': '创建时间',
  'pages.deviceControl.drinkManagement.updateTime': '更新时间',
  'pages.deviceControl.drinkManagement.drinkPrice': '饮品价格',
  'pages.deviceControl.drinkManagement.description': '饮品描述',
  'pages.deviceControl.drinkManagement.status': '状态',
  'pages.deviceControl.drinkManagement.price': '价格',
  'pages.deviceControl.drinkManagement.ingredients': '配料',
  'pages.deviceControl.drinkManagement.beverageCount': '饮品数量',
  'pages.deviceControl.drinkManagement.configName': '配置名称',
  'pages.deviceControl.drinkManagement.drinkDetail': '饮品详情',
  'pages.deviceControl.drinkManagement.beverageInfo': '饮品配方',
  // 设备管理 - 饮品信息
  'pages.deviceControl.beverageInformation.beverageId': '饮品ID',
  'pages.deviceControl.beverageInformation.nameCn': '饮品名称',
  'pages.deviceControl.beverageInformation.nameEn': '英文名称',
  'pages.deviceControl.beverageInformation.status': '状态',
  'pages.deviceControl.beverageInformation.createTime': '创建时间',
  'pages.deviceControl.beverageInformation.updateTime': '更新时间',
  // 设备管理 - 设备升级包
  'pages.deviceControl.deviceUpgrade.deviceUpgradeID': '升级包ID',
  'pages.deviceControl.deviceUpgrade.deviceModel': '设备型号',
  'pages.deviceControl.deviceUpgrade.version': '版本号',
  'pages.deviceControl.deviceUpgrade.createTime': '创建时间',
  'pages.deviceControl.deviceUpgrade.updateTime': '更新时间',
  'pages.accessControl.deviceUpgrade.deviceType': '设备分类',
  'pages.deviceControl.deviceUpgrade.fileSize': '文件大小',
  'pages.deviceControl.deviceUpgrade.status': '状态',
  'pages.deviceControl.deviceUpgrade.packageType': '升级包类型',
  // 设备管理 - 设备说明书
  'pages.deviceControl.deviceManual.deviceManualID': '说明书ID',
  'pages.deviceControl.deviceManual.deviceModel': '设备型号',
  'pages.deviceControl.deviceManual.content': '说明书内容',
  'pages.deviceControl.deviceManual.createTime': '创建时间',
  'pages.deviceControl.deviceManual.updateTime': '更新时间',
  'pages.deviceControl.deviceManual.documentTitle': '说明书标题',
  'pages.deviceControl.deviceManual.deviceType': '设备分类',
  'pages.deviceControl.deviceManual.version': '版本号',
  'pages.deviceControl.deviceManual.fileSize': '文件大小',
  // 应用管理 - 应用账户
  'pages.applicationManagement.applicationAccount.id': 'ID',
  'pages.applicationManagement.applicationAccount.appName': '应用名称',
  'pages.applicationManagement.applicationAccount.appId': '应用ID',
  'pages.applicationManagement.applicationAccount.appKey': '应用密钥',
  'pages.applicationManagement.applicationAccount.status': '状态',
  'pages.applicationManagement.applicationAccount.createTime': '创建时间',
  'pages.applicationManagement.applicationAccount.updateTime': '更新时间',
  // 应用管理 - 应用升级包
  'pages.applicationManagement.applicationUpgradePackage.id': 'ID',
  'pages.applicationManagement.applicationUpgradePackage.appName': '应用名称',
  'pages.applicationManagement.applicationUpgradePackage.version': '版本号',
  'pages.applicationManagement.applicationUpgradePackage.platform': '平台',
  'pages.applicationManagement.applicationUpgradePackage.size': '大小',
  'pages.applicationManagement.applicationUpgradePackage.status': '状态',
  'pages.applicationManagement.applicationUpgradePackage.releaseTime': '发布时间',
  // 应该管理 - 应用用户设备
  'pages.applicationManagement.applicationUserDevice.id': 'ID',
  'pages.applicationManagement.applicationUserDevice.userName': '用户名',
  'pages.applicationManagement.applicationUserDevice.appName': '应用名称',
  'pages.applicationManagement.applicationUserDevice.deviceName': '设备名称',
  'pages.applicationManagement.applicationUserDevice.deviceType': '设备类型',
  'pages.applicationManagement.applicationUserDevice.bindTime': '绑定时间',
  'pages.applicationManagement.applicationUserDevice.lastActiveTime': '最后活跃时间',
  'pages.applicationManagement.applicationUserDevice.status': '设备状态',
  // 应用管理 - 应用协议
  'pages.applicationManagement.applicationAgreement.id': 'ID',
  'pages.applicationManagement.applicationAgreement.appName': '应用名称',
  'pages.applicationManagement.applicationAgreement.type': '协议类型',
  'pages.applicationManagement.applicationAgreement.version': '版本号',
  'pages.applicationManagement.applicationAgreement.content': '协议内容',
  'pages.applicationManagement.applicationAgreement.status': '状态',
  'pages.applicationManagement.applicationAgreement.createTime': '创建时间',
  'pages.applicationManagement.applicationAgreement.updateTime': '更新时间',
  'pages.applicationManagement.applicationAgreement.title': '协议名称',
  'pages.applicationManagement.applicationAgreement.publishTime': '发布时间',
  /** 通用标识 */
  'pages.common.id': 'ID',
  /** 通用操作 */
  'pages.common.operation': '操作',
  'pages.common.view': '查看',
  'pages.common.edit': '编辑',
  'pages.common.delete': '删除',
  'pages.common.add': '新增',
  'pages.common.save': '保存',
  'pages.common.cancel': '取消',
  'pages.common.confirm': '确定',
  'pages.common.close': '关闭',
  'pages.common.search': '搜索',
  'pages.common.reset': '重置',
  'pages.common.refresh': '刷新',
  'pages.common.download': '下载',
  'pages.common.retry': '重试',
  'pages.common.publish': '发布',
  'pages.common.unbind': '解绑',
  'pages.common.upload': '上传',
  'pages.common.batchDelete': '批量删除',
  'pages.common.selectedCount': '已选择 {count} 项',
  'pages.common.totalCount': '共 {total} 条',
  'pages.common.totalRecords': '共 {total} 条记录',
  /** 通用状态 */
  'pages.common.status.enable': '启用',
  'pages.common.status.disable': '禁用',
  'pages.common.status.yes': '是',
  'pages.common.status.no': '否',
  'pages.common.status.unknown': '未知',
  'pages.common.status.online': '在线',
  'pages.common.status.offline': '离线',
  'pages.common.status.success': '成功',
  'pages.common.status.failed': '失败',
  'pages.common.status.all': '全部',
  'pages.common.status.listed': '上架',
  'pages.common.status.delisted': '下架',
  'pages.common.status.pending': '待审核',
  /** 通用确认弹窗 */
  'pages.common.confirmDelete': '确认删除',
  'pages.common.confirmPublish': '确认发布',
  'pages.common.confirmDeactivate': '确认注销',
  'pages.common.confirmUnbind': '确认解绑',
  /** 通用提示 */
  'pages.common.uploadSuccess': '上传成功',
  'pages.common.uploadFailed': '上传失败',
  'pages.common.createSuccess': '创建成功',
  'pages.common.createFailed': '创建失败',
  'pages.common.updateSuccess': '更新成功',
  'pages.common.updateFailed': '更新失败',
  'pages.common.deleteSuccess': '删除成功',
  'pages.common.deleteFailed': '删除失败',
  'pages.common.operateFailed': '操作失败',
  'pages.common.loadFailed': '获取数据失败',
  'pages.common.publishConfirm': '确认发布',
  'pages.common.publishSuccess': '发布成功',
  'pages.common.publishFailed': '发布失败',
  /** 应用账户 */
  'pages.applicationManagement.applicationAccount.userName': '用户名',
  'pages.applicationManagement.applicationAccount.nickName': '昵称',
  'pages.applicationManagement.applicationAccount.email': '邮箱',
  'pages.applicationManagement.applicationAccount.phone': '电话',
  'pages.applicationManagement.applicationAccount.openId': 'Open ID',
  'pages.applicationManagement.applicationAccount.role': '角色',
  'pages.applicationManagement.applicationAccount.uniqueId': 'Unique ID',
  'pages.applicationManagement.applicationAccount.userName.placeholder': '请输入用户名',
  'pages.applicationManagement.applicationAccount.nickName.placeholder': '请输入昵称',
  'pages.applicationManagement.applicationAccount.email.placeholder': '请输入邮箱',
  'pages.applicationManagement.applicationAccount.email.invalid': '请输入有效的邮箱地址',
  'pages.applicationManagement.applicationAccount.phone.placeholder': '请输入电话',
  'pages.applicationManagement.applicationAccount.status.placeholder': '请选择状态',
  'pages.applicationManagement.applicationAccount.openId.placeholder': '请输入Open ID',
  'pages.applicationManagement.applicationAccount.role.placeholder': '请选择角色',
  'pages.applicationManagement.applicationAccount.uniqueId.placeholder': '请输入Unique ID',
  'pages.applicationManagement.applicationAccount.createTime': '创建时间',
  'pages.applicationManagement.applicationAccount.updateTime': '更新时间',
  'pages.applicationManagement.applicationAccount.addTitle': '新增应用账户',
  'pages.applicationManagement.applicationAccount.editTitle': '编辑应用账户',
  'pages.applicationManagement.applicationAccount.viewTitle': '查看应用账户',
  'pages.applicationManagement.applicationAccount.addAccount': '新增应用账户',
  'pages.applicationManagement.applicationAccount.role.productionManage': '生产管理员',
  'pages.applicationManagement.applicationAccount.role.production': '普通生产',
  'pages.applicationManagement.applicationAccount.role.ordinaryUser': '普通用户',
  /** 应用协议 */
  'pages.applicationManagement.applicationAgreement.language': '语言',
  'pages.applicationManagement.applicationAgreement.fileName': '文件名称',
  'pages.applicationManagement.applicationAgreement.language.cn': '中文',
  'pages.applicationManagement.applicationAgreement.language.en': '英文',
  'pages.applicationManagement.applicationAgreement.type.privacy': '隐私协议',
  'pages.applicationManagement.applicationAgreement.type.service': '服务协议',
  'pages.applicationManagement.applicationAgreement.addTitle': '新增协议',
  'pages.applicationManagement.applicationAgreement.editTitle': '编辑协议',
  'pages.applicationManagement.applicationAgreement.deleteConfirm': '确定要删除协议「{name}」吗？此操作不可撤销。',
  'pages.applicationManagement.applicationAgreement.placeholder.name': '请输入协议名称',
  'pages.applicationManagement.applicationAgreement.placeholder.language': '请选择语言',
  'pages.applicationManagement.applicationAgreement.placeholder.type': '请选择协议类型',
  /** 应用用户设备 */
  'pages.applicationManagement.applicationUserDevice.userId': '用户ID',
  'pages.applicationManagement.applicationUserDevice.nickname': '用户昵称',
  'pages.applicationManagement.applicationUserDevice.deviceId': '设备ID',
  'pages.applicationManagement.applicationUserDevice.deviceModel': '设备型号',
  'pages.applicationManagement.applicationUserDevice.deviceName': '设备名称',
  'pages.applicationManagement.applicationUserDevice.macAddress': 'MAC地址',
  /** 设备说明书 */
  'pages.deviceControl.deviceManual.uploadManual': '上传说明书',
  /** 设备升级包 */
  'pages.deviceControl.deviceUpgrade.uploadPackage': '上传升级包',
  'pages.deviceControl.deviceUpgrade.deviceName': '设备名称',
  'pages.deviceControl.deviceUpgrade.deviceStatus': '设备状态',
  'pages.deviceControl.deviceUpgrade.packageType': '升级包类型',
  'pages.deviceControl.deviceUpgrade.forceUpgrade': '强制升级',
  'pages.deviceControl.deviceUpgrade.nonForceUpgrade': '非强制升级',
  /** 设备配置组 */
  'pages.deviceControl.configGroup.configGroupID': '配置组ID',
  'pages.deviceControl.configGroup.configGroupName': '配置组名称',
  'pages.deviceControl.configGroup.seriesName': '所属设备系列',
  'pages.deviceControl.configGroup.addConfigGroup': '新增设备配置组',
  'pages.deviceControl.configGroup.editTitle': '编辑设备配置组',
  'pages.deviceControl.configGroup.addTitle': '新增设备配置组',
  'pages.deviceControl.configGroup.name': '配置组名称',
  'pages.deviceControl.configGroup.placeholderName': '请输入配置组名称',
  'pages.deviceControl.configGroup.ruleName': '请输入配置组名称',
  'pages.deviceControl.configGroup.ruleNameMax': '配置组名称长度不能超过50个字符',
  'pages.deviceControl.configGroup.placeholderSeries': '请选择所属设备系列',
  'pages.deviceControl.configGroup.ruleSeries': '请选择所属设备系列',
  'pages.deviceControl.configGroup.fetchSeriesFailed': '获取设备系列列表失败',
  'pages.deviceControl.configGroup.deleteConfirm': '确定要删除设备配置组「{name}」吗？此操作不可撤销。',
  /** 设备配置 */
  'pages.deviceControl.config.configDeviceID': '配置ID',
  'pages.deviceControl.config.configName': '配置名称',
  'pages.deviceControl.config.specs': '规格',
  'pages.deviceControl.config.configGroupName': '配置组名称',
  'pages.deviceControl.config.deviceModelName': '设备型号名称',
  'pages.deviceControl.config.status': '状态',
  'pages.deviceControl.config.addConfig': '新增设备配置',
  'pages.deviceControl.config.deleteConfirm': '确定要删除设备配置「{name}」吗？此操作不可撤销。',
  /** 设备分类 */
  'pages.deviceControl.category.categoryId': '分类ID',
  'pages.deviceControl.category.series': '设备系列',
  'pages.deviceControl.category.addCategory': '新增设备分类',
  'pages.deviceControl.category.editTitle': '编辑设备分类',
  'pages.deviceControl.category.addTitle': '新增设备分类',
  'pages.deviceControl.category.categoryName': '设备分类名称',
  'pages.deviceControl.category.placeholderName': '请输入设备分类名称',
  'pages.deviceControl.category.ruleName': '请输入设备分类名称',
  'pages.deviceControl.category.ruleMaxLength': '设备分类名称长度不能超过50个字符',
  'pages.deviceControl.category.seriesSelect': '所属设备系列',
  'pages.deviceControl.category.placeholderSeries': '请选择所属设备系列',
  'pages.deviceControl.category.ruleSeries': '请选择所属设备系列',
  /** 设备分类 - 消息提示 */
  'pages.deviceControl.category.deleteConfirm': '确定要删除该设备分类吗？此操作不可撤销。',
  'pages.deviceControl.category.fetchSeriesFailed': '获取设备系列列表失败',
  'pages.deviceControl.category.fetchListFailed': '获取设备分类列表失败',
  /** 设备系列 */
  'pages.deviceControl.series.addSeries': '新增设备系列',
  'pages.deviceControl.series.deviceSeriesID': '系列ID',
  'pages.deviceControl.series.deviceSeriesName': '设备系列名称',
  'pages.deviceControl.series.deleteConfirm': '确定要删除「{name}」这个设备系列吗？删除后无法恢复。',
  'pages.deviceControl.series.deleteSuccess': '设备系列删除成功',
  'pages.deviceControl.series.deleteFailed': '设备系列删除失败',
  'pages.deviceControl.series.placeholderName': '请输入设备系列名称',
  'pages.deviceControl.series.ruleName': '请输入设备系列名称',
  'pages.deviceControl.series.ruleNameMax': '设备系列名称长度不能超过50个字符',
  /** 设备型号 */
  'pages.deviceControl.model.serial': '串口',
  'pages.deviceControl.model.android': '安卓',
  'pages.deviceControl.model.addModel': '新增设备型号',
  'pages.deviceControl.model.editTitle': '编辑设备型号',
  'pages.deviceControl.model.addTitle': '新增设备型号',
  'pages.deviceControl.model.editDevice': '编辑设备信息',
  'pages.deviceControl.model.deviceId': '设备ID',
  'pages.deviceControl.model.deviceModel': '设备型号',
  'pages.deviceControl.model.deviceCategory': '设备分类',
  'pages.deviceControl.model.extModel': '外部型号（宣传型号）',
  'pages.deviceControl.model.type': '类型',
  'pages.deviceControl.model.selectCategory': '请选择设备分类',
  'pages.deviceControl.model.selectType': '请选择类型',
  'pages.deviceControl.model.selectModel': '请选择设备型号',
  'pages.deviceControl.model.selectStatus': '请选择状态',
  'pages.deviceControl.model.ruleDeviceId': '请输入设备ID',
  'pages.deviceControl.model.placeholderDeviceId': '请输入设备ID',
  'pages.deviceControl.model.ruleModel': '请输入设备型号',
  'pages.deviceControl.model.placeholderModel': '请输入设备型号名称',
  'pages.deviceControl.model.ruleName': '请输入设备型号名称',
  'pages.deviceControl.model.placeholderName': '请输入设备型号名称',
  'pages.deviceControl.model.ruleCategory': '请选择设备分类',
  'pages.deviceControl.model.ruleExtModel': '请输入外部型号',
  'pages.deviceControl.model.placeholderExtModel': '请输入外部型号（宣传型号）',
  /** 设备型号 - 消息提示 */
  'pages.deviceControl.model.fetchModelListFailed': '获取设备型号列表失败',
  'pages.deviceControl.model.fetchCategoryListFailed': '获取设备分类列表失败',
  'pages.deviceControl.model.deleteConfirm': '确定要删除「{name}」这个设备型号吗？删除后无法恢复。',
  'pages.deviceControl.model.deleteSuccess': '设备型号删除成功',
  'pages.deviceControl.model.deleteFailed': '设备型号删除失败',
  'pages.deviceControl.model.addSuccess': '设备型号添加成功',
  'pages.deviceControl.model.addFailed': '设备型号添加失败',
  'pages.deviceControl.model.formValidateFailed': '表单验证失败或添加失败',
  'pages.deviceControl.model.updateSuccess': '设备型号更新成功',
  'pages.deviceControl.model.updateFailed': '设备型号更新失败',
  /** 设备列表 */
  'pages.deviceControl.list.macId': 'MAC ID',
  'pages.deviceControl.list.deviceConfig': '设备配置',
  'pages.deviceControl.list.editDevice': '编辑设备',
  'pages.deviceControl.list.editDeviceInfo': '编辑设备信息',
  'pages.deviceControl.list.snCode': 'SN码',
  'pages.deviceControl.list.deviceNumber': '设备号',
  'pages.deviceControl.list.enableDisable': '启用/禁用',
  'pages.deviceControl.list.transferTitle': '设备号迁移',
  'pages.deviceControl.list.transferFrom': '当前 MAC ID',
  'pages.deviceControl.list.transferTo': '迁移到 MAC ID',
  'pages.deviceControl.list.transferPlaceholder': '请输入将要迁移到的 MAC ID',
  'pages.deviceControl.list.notSelected': '未选择',
  'pages.deviceControl.list.toolTransfer': '设备号迁移',
  'pages.deviceControl.list.unbindConfirm': '确定要解绑设备 {id} 吗？解绑后需要重新绑定。',
  'pages.deviceControl.list.deactivateConfirm': '确定要注销{id}这个设备吗？注销后无法恢复。',
  'pages.deviceControl.list.id': 'ID',
  'pages.deviceControl.list.region': '地区',
  'pages.deviceControl.list.iotStatus': 'IoT状态',
  'pages.deviceControl.list.inactive': '未激活',
  'pages.deviceControl.list.selectModel': '请选择设备型号',
  'pages.deviceControl.list.deviceModel': '设备型号',
  'pages.deviceControl.list.deactivateTitle': '确认注销',
  'pages.deviceControl.list.deactivateSuccess': '设备注销成功',
  'pages.deviceControl.list.deactivateFailed': '设备注销失败',
  'pages.deviceControl.list.updateSuccess': '设备信息更新成功',
  'pages.deviceControl.list.updateFailed': '设备信息更新失败',
  'pages.deviceControl.list.formValidateFailed': '表单验证失败或更新失败',
  'pages.deviceControl.list.migrateSuccess': '设备号迁移成功',
  'pages.deviceControl.list.migrateFailed': '设备号迁移失败',
  'pages.deviceControl.list.unbindSuccess': '设备解绑成功',
  'pages.deviceControl.list.unbindFailed': '设备解绑失败',
  'pages.deviceControl.list.fetchModelListFailed': '获取设备型号列表失败',
  'pages.deviceControl.list.fetchConfigListFailed': '获取设备配置列表失败',
  'pages.deviceControl.list.snCodeRequired': '请输入SN码',
  'pages.deviceControl.list.snCodePlaceholder': '请输入SN码',
  'pages.deviceControl.list.deviceNumberRequired': '请输入设备号',
  'pages.deviceControl.list.deviceNumberPlaceholder': '请输入设备号',
  'pages.deviceControl.list.selectModelRequired': '请选择设备型号',
  'pages.deviceControl.list.deviceConfigRequired': '请选择设备配置',
  'pages.deviceControl.list.deviceConfigPlaceholder': '请选择设备配置',
  'pages.deviceControl.list.enableDisableRequired': '请选择启用/禁用',
  'pages.deviceControl.list.enableDisablePlaceholder': '请选择启用/禁用',
  'pages.deviceControl.list.view': '查看',
  'pages.deviceControl.list.viewDevice': '设备详情',
  'pages.deviceControl.list.viewDeviceInfo': '设备详情',
  'pages.deviceControl.list.close': '关闭',
  'pages.deviceControl.list.deviceConfigName': '设备配置名称',
  'pages.deviceControl.list.detail': '详情',
  /** 设备类型 */
  'pages.deviceControl.type.typeId': '分类ID',
  'pages.deviceControl.type.typeName': '分类名称',
  'pages.deviceControl.type.typeDesc': '分类描述',
  'pages.deviceControl.type.parentId': '父分类ID',
  'pages.deviceControl.type.addType': '新增设备分类',
  /** 饮品信息 */
  'pages.deviceControl.beverage.addTitle': '新增饮品信息',
  'pages.deviceControl.beverage.editTitle': '编辑饮品信息',
  'pages.deviceControl.beverage.beverageId': '饮品ID',
  'pages.deviceControl.beverage.beverageIdPlaceholder': '请输入饮品ID',
  'pages.deviceControl.beverage.beverageIdRequired': '请输入饮品ID',
  'pages.deviceControl.beverage.nameCn': '中文名称',
  'pages.deviceControl.beverage.nameCnPlaceholder': '请输入中文名称',
  'pages.deviceControl.beverage.nameCnRequired': '请输入中文名称',
  'pages.deviceControl.beverage.nameEn': '英文名称',
  'pages.deviceControl.beverage.nameEnPlaceholder': '请输入英文名称',
  'pages.deviceControl.beverage.nameEnRequired': '请输入英文名称',
  'pages.deviceControl.beverage.applicableDevice': '适用设备',
  'pages.deviceControl.beverage.applicableDevicePlaceholder': '请选择适用设备',
  'pages.deviceControl.beverage.applicableDeviceRequired': '请选择适用设备',
  'pages.deviceControl.beverage.serialDevice': '串口设备',
  'pages.deviceControl.beverage.androidDevice': '安卓设备',
  'pages.deviceControl.beverage.statusPlaceholder': '请选择状态',
  'pages.deviceControl.beverage.statusRequired': '请选择状态',
  'pages.deviceControl.beverage.deleteConfirm': '确定要删除「{name}」吗？删除后无法恢复。',
  'pages.deviceControl.beverage.otherLanguages': '其他语言名称',
  'pages.deviceControl.beverage.traditionalChinese': '繁体中文',
  'pages.deviceControl.beverage.traditionalChinesePlaceholder': '请输入繁体中文名称',
  'pages.deviceControl.beverage.korean': '韩语',
  'pages.deviceControl.beverage.koreanPlaceholder': '请输入韩语名称',
  'pages.deviceControl.beverage.russian': '俄语',
  'pages.deviceControl.beverage.russianPlaceholder': '请输入俄语名称',
  'pages.deviceControl.beverage.french': '法语',
  'pages.deviceControl.beverage.frenchPlaceholder': '请输入法语名称',
  'pages.deviceControl.beverage.spanish': '西班牙语',
  'pages.deviceControl.beverage.spanishPlaceholder': '请输入西班牙语名称',
  'pages.deviceControl.beverage.portuguese': '葡萄牙语',
  'pages.deviceControl.beverage.portuguesePlaceholder': '请输入葡萄牙语名称',
  'pages.deviceControl.beverage.indonesian': '印尼语',
  'pages.deviceControl.beverage.indonesianPlaceholder': '请输入印尼语名称',
  'pages.deviceControl.beverage.lithuanian': '立陶宛语',
  'pages.deviceControl.beverage.lithuanianPlaceholder': '请输入立陶宛语名称',
  'pages.deviceControl.beverage.ukrainian': '乌克兰语',
  'pages.deviceControl.beverage.ukrainianPlaceholder': '请输入乌克兰语名称',
  'pages.deviceControl.beverage.czech': '捷克语',
  'pages.deviceControl.beverage.czechPlaceholder': '请输入捷克语名称',
  'pages.deviceControl.beverage.image': '饮品图片',
  'pages.deviceControl.beverage.imageError': '只能上传图片文件',
  'pages.deviceControl.beverage.imageSizeError': '图片大小不能超过 10MB',
  'pages.deviceControl.beverage.initUploadFailed': '初始化上传失败',
  'pages.deviceControl.beverage.getUploadIdFailed': '获取上传ID失败',
  'pages.deviceControl.beverage.uploadFailed': '上传文件失败',
  'pages.deviceControl.beverage.mergeFailed': '合并文件失败',
  'pages.deviceControl.beverage.status': '状态',
  'pages.deviceControl.beverage.all': '全部',
  /** 饮品信息 - 消息提示 */
  'pages.deviceControl.beverage.deleteSuccess': '删除成功',
  'pages.deviceControl.beverage.deleteFailed': '删除失败',
  'pages.deviceControl.beverage.loadFailed': '获取饮品信息失败',
  /** 饮品列表 */
  'pages.deviceControl.drink.drinkID': '饮品ID',
  'pages.deviceControl.drink.drinkName': '饮品名称',
  'pages.deviceControl.drink.beverageCount': '饮品数量',
  'pages.deviceControl.drink.configName': '配置名称',
  'pages.deviceControl.drink.drinkDetail': '饮品详情',
  'pages.deviceControl.drink.beverageInfo': '饮品详情',
  'pages.deviceControl.drink.alertMessage': '当前此功能只有串口设备使用，安卓设备未使用。',
  'pages.deviceControl.drink.addDrink': '新增饮品',
  'pages.deviceControl.drink.editDrink': '编辑饮品',
  'pages.deviceControl.drink.addTitle': '新增饮品',
  'pages.deviceControl.drink.drinkNamePlaceholder': '请输入饮品名称',
  'pages.deviceControl.drink.deleteConfirm': '确定要删除「{name}」吗？删除后无法恢复。',
  'pages.deviceControl.drink.deviceConfig': '设备配置信息',
  'pages.deviceControl.drink.drinkList': '饮品列表',
  'pages.deviceControl.drink.pleaseEnterDrinkName': '请输入饮品名称',
  'pages.deviceControl.drink.configNamePlaceholder': '请输入配置名称，多个用逗号分隔',
  'pages.deviceControl.drink.pleaseSelectConfig': '请选择设备配置信息，至少关联一个',
  'pages.deviceControl.drink.pleaseEnterDrinkList': '请输入饮品列表',
  'pages.deviceControl.drink.drinkListPlaceholder': '请输入饮品列表，格式为JSON字符串',
  /** 饮品列表 - 消息提示 */
  'pages.deviceControl.drink.fetchConfigFailed': '获取设备配置信息失败',
  'pages.deviceControl.drink.loadFailed': '获取饮品列表失败',
  'pages.deviceControl.drink.updateSuccess': '饮品更新成功',
  'pages.deviceControl.drink.createSuccess': '饮品创建成功',
  'pages.deviceControl.drink.submitFailed': '表单提交失败',
  /** 通用 */
  'pages.common.createTime': '创建时间',
  'pages.common.updateTime': '更新时间',
  'pages.common.tips': '提示',
  /** 升级包公共 */
  'pages.packageManagement.upgrade.editTitle': '编辑升级包',
  'pages.packageManagement.upgrade.addTitle': '新增升级包',
  'pages.packageManagement.upgrade.packageName': '升级包名称',
  'pages.packageManagement.upgrade.version': '版本号',
  'pages.packageManagement.upgrade.description': '描述',
  'pages.packageManagement.upgrade.type': '类型',
  'pages.packageManagement.upgrade.forceUpdate': '强制更新',
  'pages.packageManagement.upgrade.status': '状态',
  'pages.packageManagement.upgrade.all': '全部',
  'pages.packageManagement.upgrade.uploadFile': '上传文件',
  'pages.packageManagement.upgrade.submit': '提交',
  'pages.packageManagement.upgrade.uploadedFile': '已上传文件：',
  'pages.packageManagement.upgrade.fileLink': '文件链接：',
  'pages.packageManagement.upgrade.fileSize': '文件大小：',
  'pages.packageManagement.upgrade.reUpload': '重新上传文件',
  'pages.packageManagement.upgrade.clickUpload': '点击上传文件',
  'pages.packageManagement.upgrade.cnDesc': '中文描述',
  'pages.packageManagement.upgrade.enDesc': '英文描述',
  /** 应用升级包 */
  'pages.packageManagement.appUpgrade.buildNumber': '构建号',
  'pages.packageManagement.appUpgrade.validation.buildNumber': '请输入构建号',
  'pages.packageManagement.appUpgrade.placeholder.buildNumber': '请输入构建号',
  'pages.packageManagement.appUpgrade.detailTitle': '升级包详情',
  'pages.packageManagement.appUpgrade.detail.descriptionInfo': '描述信息',
  'pages.packageManagement.appUpgrade.addPackage': '添加升级包',
  'pages.packageManagement.appUpgrade.detail.cn': '中文：',
  'pages.packageManagement.appUpgrade.detail.tw': '繁体：',
  'pages.packageManagement.appUpgrade.detail.hk': '香港：',
  'pages.packageManagement.appUpgrade.detail.en': '英文：',
  'pages.packageManagement.appUpgrade.detail.fr': '法文：',
  'pages.packageManagement.appUpgrade.detail.ja': '日文：',
  'pages.packageManagement.appUpgrade.detail.ko': '韩文：',
  'pages.packageManagement.appUpgrade.detail.ru': '俄文：',
  'pages.packageManagement.appUpgrade.detail.chinese': '中文',
  'pages.packageManagement.appUpgrade.detail.traditional': '繁体',
  'pages.packageManagement.appUpgrade.detail.hongKong': '香港',
  'pages.packageManagement.appUpgrade.detail.english': '英文',
  'pages.packageManagement.appUpgrade.detail.french': '法文',
  'pages.packageManagement.appUpgrade.detail.japanese': '日文',
  'pages.packageManagement.appUpgrade.detail.korean': '韩文',
  'pages.packageManagement.appUpgrade.detail.russian': '俄文',
  'pages.packageManagement.appUpgrade.detail.downloadLink': '下载链接：',
  'pages.packageManagement.appUpgrade.detail.generalLink': '通用链接',
  'pages.packageManagement.appUpgrade.detail.commonLink': '通用链接：',
  'pages.packageManagement.appUpgrade.detail.iosLink': 'iOS链接：',
  'pages.packageManagement.appUpgrade.detail.androidLink': 'Android链接：',
  'pages.packageManagement.appUpgrade.detail.qrcode': '二维码：',
  'pages.packageManagement.appUpgrade.detail.qrCode': '二维码',
  'pages.packageManagement.appUpgrade.noDownloadLink': '暂无下载链接',
  /** 咖啡机升级包 */
  'pages.packageManagement.coffeeUpgrade.name': '名称',
  'pages.packageManagement.coffeeUpgrade.configName': '配置名称',
  'pages.packageManagement.coffeeUpgrade.fileSize': '文件大小',
  'pages.packageManagement.coffeeUpgrade.type': '类型',
  'pages.packageManagement.coffeeUpgrade.environment': '环境',
  'pages.packageManagement.coffeeUpgrade.environment.product': '生产',
  'pages.packageManagement.coffeeUpgrade.environment.test': '测试',
  'pages.packageManagement.coffeeUpgrade.config': '配置信息',
  'pages.packageManagement.coffeeUpgrade.detail.accessLink': '访问链接：',
  /** 升级包类型 */
  'pages.packageManagement.upgrade.typeOptions.io': 'IO',
  'pages.packageManagement.upgrade.typeOptions.uiColor': 'UI(彩膜版)',
  'pages.packageManagement.upgrade.typeOptions.audio': '音频',
  'pages.packageManagement.upgrade.typeOptions.apk': '安卓apk',
  'pages.packageManagement.upgrade.typeOptions.androidApk': '安卓apk',
  'pages.packageManagement.upgrade.typeOptions.uiSerial': 'UI(串口屏)',
  /** 升级包弹窗 - 校验 & placeholder */
  'pages.packageManagement.upgrade.validation.packageName': '请输入升级包名称',
  'pages.packageManagement.upgrade.placeholder.packageName': '请输入升级包名称',
  'pages.packageManagement.upgrade.validation.version': '请输入版本号',
  'pages.packageManagement.upgrade.placeholder.version': '请输入版本号，如：v1.0.0',
  'pages.packageManagement.upgrade.validation.cnDesc': '请输入中文描述',
  'pages.packageManagement.upgrade.placeholder.cnDesc': '请输入中文描述',
  'pages.packageManagement.upgrade.validation.enDesc': '请输入英文描述',
  'pages.packageManagement.upgrade.placeholder.enDesc': '请输入英文描述',
  'pages.packageManagement.upgrade.validation.forceUpdate': '请选择是否强制更新',
  'pages.packageManagement.upgrade.placeholder.forceUpdate': '请选择是否强制更新',
  'pages.packageManagement.upgrade.validation.status': '请选择状态',
  'pages.packageManagement.upgrade.placeholder.status': '请选择状态',
  'pages.packageManagement.upgrade.validation.desc': '请输入描述',
  'pages.packageManagement.upgrade.placeholder.desc': '请输入描述',
  'pages.packageManagement.upgrade.validation.type': '请选择类型',
  'pages.packageManagement.upgrade.placeholder.type': '请选择类型',
  'pages.packageManagement.coffeeUpgrade.validation.config': '请选择配置信息',
  'pages.packageManagement.coffeeUpgrade.placeholder.config': '请选择配置信息',
  'pages.packageManagement.coffeeUpgrade.placeholder.version': '请输入版本号，如：78.101',
  /** 上传升级包弹窗 */
  'pages.packageManagement.upload.title': '上传升级包',
  'pages.packageManagement.upload.fileName': '文件名：',
  'pages.packageManagement.upload.fileSize': '文件大小：',
  'pages.packageManagement.upload.uploadProgress': '上传进度：{progress}%',
  'pages.packageManagement.upload.uploadSuccessText': '文件上传成功！',
  'pages.packageManagement.upload.uploadFailedText': '文件上传失败，请重试！',
  'pages.packageManagement.upload.uploading': '上传中...',
  'pages.packageManagement.upload.reUpload': '重新上传',
  'pages.packageManagement.upload.confirmUpload': '确定上传',
  'pages.packageManagement.upload.selectFile': '请选择要上传的文件',
  'pages.packageManagement.upload.uploadFailRetry': '上传失败，请重试',
  'pages.packageManagement.upload.getUploadIdFailed': '获取上传ID失败，请检查网络连接',
  'pages.packageManagement.upload.initUploadFailed': '初始化上传失败',
  'pages.packageManagement.upload.initChunkUploadFailed': '初始化分片上传失败',
  'pages.packageManagement.upload.chunkUploadFailed': '分片 {index} 上传失败',
  'pages.packageManagement.upload.chunkReuploadFailed': '分片 {index} 重新上传失败',
  'pages.packageManagement.upload.remergeFailed': '重新合并文件失败',
  'pages.packageManagement.upload.getMissingChunksFailed': '获取缺少的片数失败',
  'pages.packageManagement.upload.mergeFailed': '合并文件失败',
  /** 协议管理弹窗 */
  'pages.applicationManagement.agreementPop.agreementName': '协议名称',
  'pages.applicationManagement.agreementPop.agreementName.placeholder': '请输入协议名称',
  'pages.applicationManagement.agreementPop.language': '语言',
  'pages.applicationManagement.agreementPop.language.placeholder': '请选择语言',
  'pages.applicationManagement.agreementPop.agreementType': '协议类型',
  'pages.applicationManagement.agreementPop.agreementType.placeholder': '请选择协议类型',
  'pages.applicationManagement.agreementPop.uploadAgreement': '上传协议',
  'pages.applicationManagement.agreementPop.reUpload': '重新上传协议',
  'pages.applicationManagement.agreementPop.clickUpload': '点击上传协议',
  'pages.applicationManagement.agreementPop.uploadedFile': '已上传文件：',
  'pages.applicationManagement.agreementPop.fileLink': '文件链接：',
  'pages.applicationManagement.agreementPop.uploadSuccess': '协议上传成功',
  /** 订单列表 */
  'pages.orderControl.order.number': '订单编号',
  'pages.orderControl.order.deviceId': '设备号',
  'pages.orderControl.order.productId': '产品ID',
  'pages.orderControl.order.createTime': '创建时间',
  'pages.orderControl.order.startTime': '起始时间',
  'pages.orderControl.order.endTime': '结束时间',
  'pages.orderControl.order.status': '状态',
  'pages.orderControl.order.detail': '详情',
  'pages.orderControl.order.detailTitle': '订单详情',
  'pages.orderControl.order.macId': 'MAC ID',
  'pages.orderControl.order.productName': '产品名称',
  'pages.orderControl.order.recipeName': '配方名称',
  'pages.orderControl.order.canisterId': '料罐ID',
  'pages.orderControl.order.quantity': '数量',
  'pages.orderControl.order.amount': '产品金额',
  'pages.orderControl.order.discount': '折扣',
  'pages.orderControl.order.paidAmount': '实付金额',
  'pages.orderControl.order.paymentMethod': '支付方式',
  'pages.orderControl.order.makeTime': '制作时间',
  'pages.orderControl.order.updateTime': '更新时间',
  'pages.orderControl.order.failReason': '失败原因',
  'pages.orderControl.order.queryRule': '查询规则',
  'pages.orderControl.order.queryDesc': '状态和时间为必填项；起始时间不能晚于结束时间，且时间范围不能跨月查询。',
  'pages.orderControl.order.selectStatus': '请选择订单状态',
  'pages.orderControl.order.selectTime': '请选择起始时间和结束时间',
  'pages.orderControl.order.startAfterEnd': '起始时间不能晚于结束时间',
  'pages.orderControl.order.crossMonth': '时间范围不能跨月查询',
  'pages.orderControl.order.selectStart': '请选择起始时间',
  'pages.orderControl.order.selectEnd': '请选择结束时间',
  /** 菜单管理弹窗 */
  'pages.accessControl.menu.order': '菜单排序',
  'pages.accessControl.menu.ruleOrder': '请输入菜单排序',
  'pages.accessControl.menu.placeholderOrder': '请输入菜单排序',
  'pages.accessControl.menu.name': '菜单名称',
  'pages.accessControl.menu.ruleName': '请输入菜单名称',
  'pages.accessControl.menu.placeholderName': '请输入菜单名称',
  'pages.accessControl.menu.path': '接口路径',
  'pages.accessControl.menu.placeholderPath': '请输入接口路径',
  'pages.accessControl.menu.componentsPath': '菜单路径',
  'pages.accessControl.menu.placeholderComponentsPath': '请输入菜单路径',
  'pages.accessControl.menu.icon': '菜单图标',
  'pages.accessControl.menu.placeholderIcon': '请选择菜单图标',
  'pages.accessControl.menu.type': '菜单类型',
  'pages.accessControl.menu.placeholderType': '请选择菜单类型',
  'pages.accessControl.menu.isLogin': '是否登录可见',
  'pages.accessControl.menu.isShow': '是否显示',
  'pages.accessControl.menu.type.directory': '目录',
  'pages.accessControl.menu.type.menu': '菜单',
  'pages.accessControl.menu.type.button': '按钮',
  'pages.accessControl.menu.type.api': '接口',
  'pages.accessControl.menu.icon.home': '首页',
  'pages.accessControl.menu.icon.user': '用户',
  'pages.accessControl.menu.icon.table': '表格',
  'pages.accessControl.menu.icon.menu': '菜单',
  'pages.accessControl.menu.icon.key': '钥匙',
  'pages.accessControl.menu.icon.crown': '皇冠',
  'pages.accessControl.menu.icon.smile': '笑容',
  'pages.accessControl.menu.icon.setting': '设置',
  /** 菜单管理页 - 消息提示 */
  'pages.accessControl.menuManagement.loadFailed': '获取菜单列表失败',
  'pages.accessControl.menuManagement.createSuccess': '菜单创建成功',
  'pages.accessControl.menuManagement.createFailed': '菜单创建失败',
  'pages.accessControl.menuManagement.updateSuccess': '菜单更新成功',
  'pages.accessControl.menuManagement.updateFailed': '菜单更新失败',
  'pages.accessControl.menuManagement.deleteSuccess': '菜单删除成功',
  'pages.accessControl.menuManagement.deleteFailed': '菜单删除失败',
  'pages.accessControl.menuManagement.deleteConfirm': '确定要删除这个菜单项吗？删除后无法恢复。',
  'pages.accessControl.menuManagement.formValidateFailed': '表单验证失败',
  'pages.accessControl.menuManagement.hidden': '隐藏',
  'pages.accessControl.menuManagement.loading': '加载中...',
  /** 登录页 - 表单标签 */
  'pages.login.username.label': '用户名',
  'pages.login.password.label': '密码',
  'pages.login.captcha.label': '验证码',
  'pages.login.captcha.invalid': '请输入正确的验证码!',
  'pages.login.captcha.alt': '验证码',
  'pages.login.captcha.refresh': '点击刷新',
  'pages.login.forgotPassword.notAvailable': '忘记密码功能开发中',
  'pages.login.submitText': '登 录',
  /** 驾驶舱/看板 */
  'pages.dashboard.title': '驾驶舱',
  'pages.dashboard.deviceOnlineCount': '设备在线数/总数',
  'pages.dashboard.mobileUserCount': '移动用户在线数/总数',
  'pages.dashboard.dailyCups': '日制作杯数',
  'pages.dashboard.modelCupRanking': '机型制作杯数总排名',
  'pages.dashboard.totalCups': '制作总杯数',
  'pages.dashboard.unitYuan': '元',
  'pages.dashboard.userVisits': '用户访问量',
  'pages.dashboard.drinkDistribution': '饮料制作分布',
  'pages.dashboard.drinkCupRanking': '饮料制作杯数总排名',
  'pages.dashboard.total': '总计',
  'pages.dashboard.table.rank': '排名',
  'pages.dashboard.table.name': '名称',
  'pages.dashboard.table.type': '类型',
  'pages.dashboard.table.region': '地区',
  'pages.dashboard.table.industry': '行业',
  'pages.dashboard.table.market': '市场',
  'pages.dashboard.table.percentage': '占比',
  'pages.dashboard.online': '在线',
  'pages.dashboard.offline': '离线',
  'pages.dashboard.completed': '已完成',
  'pages.dashboard.notCompleted': '未完成',
  'pages.dashboard.loading': '加载中...',
  'pages.dashboard.salesCups': '销售杯数',
  'pages.dashboard.cupsUnit': '{cups}杯',
  /** 配方物料消耗 */
  'pages.dashboard.recipeMaterialConsumption': '配方物料消耗统计',
  'pages.dashboard.totalMaterialConsumption': '总物料消耗',
  'pages.dashboard.averageConsumption': '平均消耗',
  'pages.dashboard.dataLoading': '数据加载中...',
  /** 升级包列表 - 漏洞提交 */
  'pages.upgradePackageList.uploadFileCountLimit': '上传文件总数不能超过10个',
  'pages.upgradePackageList.uploadFileSizeLimit': '单个文件大小不能超过150MB',
  'pages.upgradePackageList.mergeFileFailed': '合并文件失败',
  'pages.upgradePackageList.uploadFailed': '上传失败',
  'pages.upgradePackageList.enterEmailFirst': '请先输入邮箱地址',
  'pages.upgradePackageList.invalidEmail': '请输入有效的邮箱地址',
  'pages.upgradePackageList.verificationCodeSent': '验证码发送成功',
  'pages.upgradePackageList.severityLow': '低危',
  'pages.upgradePackageList.severityMedium': '中危',
  'pages.upgradePackageList.severityHigh': '高危',
  'pages.upgradePackageList.chunkReuploadFailed': '分片 {index} 重新上传失败',
  'pages.upgradePackageList.getMissingChunksFailed': '获取缺少的片数失败',
};
